angular.module('elfium').directive('dashboard', ['elfiumUrlService', function (elfiumUrlService) {
    return {
        restrict: 'E',
        scope: {},
        controller: 'dashboardController',
        templateUrl: elfiumUrlService.getTemplateUrl('dashboard')
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.ts